/**
 * Mirakl Feed Health API Service
 *
 * Provides API communication for:
 * - Per-marketplace feed summary (completeness, last import, pending/rejects)
 * - Gap drilldown (incomplete SKUs, missing item master, no offer)
 */

import api from '../config/api';

/**
 * Get per-marketplace Mirakl feed summary
 */
export const getSummary = async () => {
  const response = await api.get('/api/mirakl-feeds/summary');
  return response.data;
};

/**
 * Get SKU-level gap rows for a marketplace
 * @param {string} marketplace - marketplace code (e.g. 'macysus')
 * @param {string} type - gap type: 'all' | 'incomplete' | 'missing_master' | 'not_in_offers'
 */
export const getGaps = async (marketplace, type) => {
  const response = await api.get('/api/mirakl-feeds/gaps', {
    params: { marketplace, type }
  });
  return response.data;
};

export default { getSummary, getGaps };
